import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  wrapper: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  wrapperLoading: {
    backgroundColor: "#000",
  },
  wrapperContent: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    position: "relative",
    padding: `${theme.spacing.spacing12} 0`,
  },
  borderedHole: {
    position: "relative",
    height: "100%",
    width: theme.width.width107_5,
    maxHeight: 450,
    borderRadius: theme.borders.borderRadius.md,
    borderWidth: theme.borders.borderWidth[2],
    borderStyle: "solid",
    zIndex: 10,
    boxShadow: `0 0 0 99999px ${theme.palette.overlay?.dark || "rgba(16, 21, 44, 0.81)"}`,
    margin: `${theme.spacing.spacing50} 0 ${theme.spacing.spacing15}`,
    '@media (orientation: landscape)': {
      width: theme.width.width225,
      maxHeight: 215,
      margin: 0,
    },
  },
  borderedHoleLoading: {
    boxShadow: "0 0 0 99999px rgba(0, 0, 0, 1)",
  },
  holeLoadingOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: theme.spacing.spacing8,
    backgroundColor: theme.palette.black?.main ?? "#0a0a0a",
    borderRadius: theme.borders.borderRadius.md,
  },
  holeLoadingText: {
    color: theme.palette.white.main,
  },
  webcamHeader: {
    position: "fixed",
    top: 20,
    left: 0,
    zIndex: 2,
    padding: theme.spacing.spacing6,
    fontSize: theme.typography.size.xl,
    width: theme.width.fullVw,
    textAlign: "right",
    color: theme.palette.white.main,
  },
  webcam: {
    position: "fixed",
    top: 0,
    left: 0,
    objectFit: "cover",
    width: theme.width.full,
    height: "100%"
  },
  tooltipWrapper: {
    width: theme.width.ninetyVw,
    position: "absolute",
    bottom: 0,
    maxWidth: 400,
    zIndex: 10,
    height: 100,
    '@media (orientation: landscape)': {
      height: "auto",
      width: theme.width.width172_5,
    },
  },
  messageTooltip: {
    background: theme.palette.black.main,
    borderRadius: 10,
    padding: theme.spacing.spacing8,
    color: theme.palette.white.main,
    textAlign: "center",
    '@media (orientation: landscape)': {
      position: "absolute",
      bottom: theme.spacing.spacing4
    },
  },
  webcamProgress: {
    position: "absolute",
    top: 0,
    left: 0,
    width: theme.width.fullVw
  }
}));
